// // // import 'leaflet-routing-machine';
// // import { CloseOutlined } from '@ant-design/icons';
// // import { Button, Modal, message } from 'antd';
// // import React, { useState } from 'react';
// // import { useNavigate } from "react-router-dom"; 
// // import CompensatoryIcon from '../images/CompensatoryTrees.svg';
// // import InSituIcon from '../images/InSituTrees.svg';
// // import CalendarIcon from '../images/calendar.svg';
// // import TransplantIcon from '../images/TransplantTrees.svg';
// // import GirthIcon from '../images/Girth.svg';
// // import LatitudeIcon from '../images/Latitude.svg';
// // import LongitudeIcon from '../images/Longitude.svg';
// // import EditIcon from '../images/EditForm.svg';
// // import QRCODEIcon from '../images/QRCodeIcon.svg';
// // import DirectionsIcon from '../images/DirectionIcon.svg'; 
// // import "./TreeInfoModal.css";
// // import L from "leaflet";
// // import "leaflet/dist/leaflet.css";

// // const TreeInfoModal = ({ tree, visible, onClose, mapInstance, currentLocation }) => {
// //   const [zoomStyle, setZoomStyle] = useState({});
// //   const [zoomVisible, setZoomVisible] = useState(false);
// //   const [imageModalVisible, setImageModalVisible] = useState(false);
// //   const [qrModalVisible, setQrModalVisible] = useState(false);
// //   const navigate = useNavigate();

// //   const handleEditClick = () => {
// //     const token = sessionStorage.getItem('token') || localStorage.getItem('token');
// //     if (!token) {
// //       message.warning('Please log in to edit tree details.');
// //       return;
// //     }
// //     navigate(`/edit-tree/${tree.properties.tid}`, { state: { tree } });
// //   };

// //   if (!tree) return null;

// //   const treeImages = tree?.properties?.tree_images || [];
// //   const latestImage = treeImages.length > 0
// //     ? treeImages.reduce((latest, current) => current.id > latest.id ? current : latest).image
// //     : tree.properties?.image || "image is not available";
// //   const imageUrl = latestImage.includes('?') 
// //     ? `${latestImage}&t=${new Date().getTime()}` 
// //     : `${latestImage}?t=${new Date().getTime()}`;

// //   const handleMouseMove = (e) => {
// //     const { width, height, left, top } = e.target.getBoundingClientRect();
// //     const mouseX = e.clientX - left;
// //     const mouseY = e.clientY - top;
// //     const zoomX = (mouseX / width) * 100;
// //     const zoomY = (mouseY / height) * 100;
// //     setZoomStyle({
// //       backgroundPosition: `${zoomX}% ${zoomY}%`,
// //       backgroundSize: `${width * 2}% ${height * 2}%`,
// //     });
// //     setZoomVisible(true);
// //   };

// //   const handleMouseLeave = () => setZoomVisible(false);
// //   const handleImageClick = () => setImageModalVisible(true);
// //   const handleImageModalClose = () => setImageModalVisible(false);
// //   const handleQrClick = () => setQrModalVisible(true);
// //   const handleQrModalClose = () => setQrModalVisible(false);

// //   const handleDirectionsClick = () => {
// //     if (!currentLocation || !tree.geometry?.coordinates) {
// //       alert('Current location or tree location not available.');
// //       return;
// //     }
// //     const [treeLon, treeLat] = tree.geometry.coordinates;
// //     const { lat: currentLat, lng: currentLng } = currentLocation;
// //     const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${treeLat},${treeLon}`;
// //     window.open(googleMapsUrl, '_blank');
// //   };

// //   return (
// //     <Modal
// //       visible={visible}
// //       onCancel={onClose}
// //       footer={null}
// //       width={765}
// //       closable={false}
// //       className="tree-info-modal"
// //     >
// //       {(sessionStorage.getItem('token') || localStorage.getItem('token')) && (
// //         <div className="edit-container">
// //           <img src={EditIcon} alt="Edit Icon" className="edit-icon" onClick={handleEditClick} />
// //           <button className="edit-button" onClick={handleEditClick}>Edit</button>
// //         </div>
// //       )}

// //       <div className="close-button-container">
// //         <Button
// //           icon={<CloseOutlined />}
// //           onClick={onClose}
// //           type="text"
// //           className="close-button"
// //         />
// //       </div>

// //       <div className="tree-modal-container">
// //         <div
// //           className="tree-image-container"
// //           onMouseMove={handleMouseMove}
// //           onMouseLeave={handleMouseLeave}
// //           onClick={handleImageClick}
// //         >
// //           <img src={latestImage} alt="Tree" className="tree-image" />
// //         </div>

// //         <div className="tree-info-container">
// //           <p className="tree-id">ID: {tree.properties.tree_number || 'N/A'}</p>
// //           <p className="tree-name">Tree Name: <span>{tree.properties.tree_name || 'N/A'}</span></p>
// //           <p className="tree-type">
// //             Type: 
// //             <span className={tree.properties.survey_type}>
// //               {tree.properties.survey_type === 'in_situ' && <img src={InSituIcon} alt="In Situ Icon" />}
// //               {tree.properties.survey_type === 'transplant' && <img src={TransplantIcon} alt="Transplant Icon" />}
// //               {tree.properties.survey_type === 'compensatory' && <img src={CompensatoryIcon} alt="Compensatory Icon" />}
// //               {tree.properties.survey_type || 'N/A'}
// //             </span>
// //           </p>
// //           <p className="tree-scientific-name">Scientific Name: <span>{tree.properties.tree_scientific_name || 'N/A'}</span></p>
// //           <p className="tree-location">Location: {tree.properties.station_name || 'N/A'}</p>

// //           <div className="tree-additional-info">
// //             <div className="tree-info-item">
// //               <div><img src={CalendarIcon} alt="Calendar Icon" /> Date</div>
// //               <span>{tree.properties.survey_date || 'N/A'}</span>
// //             </div>
// //             <div className="tree-info-item">
// //               <div><img src={GirthIcon} alt="Girth Icon" /> Girth</div>
// //               <span>{tree.properties.girth || 'N/A'} cm</span>
// //             </div>
// //             <div className="tree-info-item">
// //               <div><img src={LatitudeIcon} alt="Latitude Icon" /> Latitude</div>
// //               <span>{tree?.geometry?.coordinates?.[1]?.toFixed(4) || 'N/A'}</span>
// //             </div>
// //             <div className="tree-info-item">
// //               <div><img src={LongitudeIcon} alt="Longitude Icon" /> Longitude</div>
// //               <span>{tree?.geometry?.coordinates?.[0]?.toFixed(4) || 'N/A'}</span>
// //             </div>
// //           </div>

// //           <div className="action-buttons">
// //             <div className="action-item">
// //               <img src={DirectionsIcon} alt="Directions Icon" onClick={handleDirectionsClick} />
// //               <button onClick={handleDirectionsClick}>GET DIRECTIONS</button>
// //             </div>
// //             {tree.properties.qr_code && (
// //               <div className="action-item">
// //                 <img src={QRCODEIcon} alt="QR Code" onClick={handleQrClick} />
// //                 <button onClick={handleQrClick}>SCAN TO VIEW INFORMATION</button>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>

// //       {zoomVisible && (
// //         <div className="zoom-panel" style={zoomStyle}>
// //           <div style={{ backgroundImage: `url(${latestImage})` }} />
// //         </div>
// //       )}

// //       <Modal
// //         visible={imageModalVisible}
// //         onCancel={handleImageModalClose}
// //         footer={null}
// //         className="image-modal"
// //       >
// //         {/* <Button icon={<CloseOutlined />} onClick={handleImageModalClose} className="close-button" /> */}
// //         <img src={latestImage} alt="Tree" />
// //       </Modal>

// //       <Modal
// //         visible={qrModalVisible}
// //         onCancel={handleQrModalClose}
// //         footer={null}
// //         className="qr-modal"
// //       >
// //         {/* <Button icon={<CloseOutlined />} onClick={handleQrModalClose} className="close-button" /> */}
// //         <img src={tree.properties.qr_code || 'image not available'} alt="QR Code" />
// //       </Modal>
// //     </Modal>
// //   );
// // };

// // export default TreeInfoModal;


// import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
// import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import { fetchTreeData } from "../assets/data";
// import TreeIcon from "../images/TreeIcon.svg"; // Single tree icon
// import LocationMarker from "../images/LocationMarker.svg";
// import { ReactComponent as FilterIcon } from "../images/FilterIcon.svg";
// import { ReactComponent as LayerIcon } from "../images/MapLayersIcon.svg";
// import { ReactComponent as RulerIcon } from "../images/RulerIcon.svg";
// import MarkerClusterGroup from "react-leaflet-markercluster";
// import FilterPanel from "../assets/FilterPanel";
// import LayerDropdown from "../assets/LayerDropdown";
// import { message } from "antd";
// import "leaflet-control-geocoder";
// import "leaflet-control-geocoder/dist/Control.Geocoder.css";
// import { debounce } from "lodash";
// import { useNavigate, useLocation } from "react-router-dom";
// import TreeInfoModal from "../assets/TreeInfoModal";
// import "./MapComponent.css";

// const MapComponent = () => {
//   const [trees, setTrees] = useState([]);
//   const [filteredTrees, setFilteredTrees] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedTree, setSelectedTree] = useState(null);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [showFilterPanel, setShowFilterPanel] = useState(false);
//   const [selectedLayer, setSelectedLayer] = useState("Street");
//   const [isDropdownOpen, setDropdownOpen] = useState(false);
//   const [currentLocation, setCurrentLocation] = useState(null);
//   const [activeButton, setActiveButton] = useState(null);

//   const mapRef = useRef(null);
//   const markerRef = useRef(null);
//   const filterPanelRef = useRef(null);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const position = useMemo(() => [19.116084601593794, 72.86542060979293], []);
//   const indiaBounds = useMemo(() => L.latLngBounds([6.5546079, 68.1113787], [35.675147, 97.395561]), []);

//   // Fetch tree data
//   useEffect(() => {
//     const loadTrees = async () => {
//       setLoading(true);
//       try {
//         const data = await fetchTreeData();
//         console.log("Fetched tree data:", data);
//         setTrees(data);
//         setFilteredTrees(data);
//         // Zoom to tree bounds after loading
//         if (data.length > 0 && mapRef.current) {
//           const bounds = L.latLngBounds(
//             data.map((tree) => [tree.geometry.coordinates[0], tree.geometry.coordinates[1]])
//           );
//           mapRef.current.fitBounds(bounds, { padding: [50, 50] });
//         }
//       } catch (error) {
//         console.error("Error loading trees:", error);
//         message.error("Failed to load tree data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadTrees();
//   }, []);

//   // Handle updated tree from navigation state
//   useEffect(() => {
//     if (location.state?.updatedTree) {
//       const updatedTree = location.state.updatedTree;
//       setTrees((prevTrees) =>
//         prevTrees.map((tree) =>
//           tree.properties.tid === updatedTree.properties.tid ? updatedTree : tree
//         )
//       );
//       setFilteredTrees((prevFiltered) =>
//         prevFiltered.map((tree) =>
//           tree.properties.tid === updatedTree.properties.tid ? updatedTree : tree
//         )
//       );
//       setSelectedTree(updatedTree);
//       setIsModalVisible(true);
//     }
//   }, [location.state]);

//   // Get current location
//   useEffect(() => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => setCurrentLocation({ lat: position.coords.latitude, lng: position.coords.longitude }),
//         (error) => console.error("Error getting geolocation:", error)
//       );
//     }
//   }, []);

//   // Update marker for current location
//   useEffect(() => {
//     if (currentLocation && mapRef.current) {
//       if (markerRef.current) {
//         markerRef.current.setLatLng([currentLocation.lat, currentLocation.lng]);
//       }
//     }
//   }, [currentLocation]);

//   // Handle map click to remove marker
//   useEffect(() => {
//     if (mapRef.current) {
//       const handleMapClick = () => {
//         if (markerRef.current) {
//           mapRef.current.removeLayer(markerRef.current);
//           markerRef.current = null;
//         }
//       };
//       mapRef.current.on("click", handleMapClick);
//       return () => mapRef.current.off("click", handleMapClick);
//     }
//   }, []);

//   const treeIconInstance = useMemo(
//     () => new L.Icon({ iconUrl: TreeIcon, iconSize: [25, 41], iconAnchor: [12, 41] }),
//     []
//   );

//   const handleMarkerClick = useCallback((tree) => {
//     setSelectedTree(tree);
//     setIsModalVisible(true);
//   }, []);

//   const handleModalClose = () => {
//     setIsModalVisible(false);
//     setSelectedTree(null);
//   };

//   const handleFilterToggle = useCallback(() => {
//     setActiveButton((prev) => (prev === "filter" ? null : "filter"));
//     setShowFilterPanel((prev) => !prev);
//   }, []);

//   const handleLayerToggle = useCallback(() => {
//     setDropdownOpen((prev) => !prev);
//     setActiveButton((prev) => (prev === "layer" ? null : "layer"));
//   }, []);

//   const handleFlyToCurrentLocation = useCallback(() => {
//     setActiveButton((prev) => (prev === "currentLoc" ? null : "currentLoc"));
//     if (currentLocation && mapRef.current) {
//       mapRef.current.flyTo([currentLocation.lat, currentLocation.lng], 13, { duration: 0.9 });
//       const locationIcon = L.Icon({ iconUrl: LocationMarker, iconSize: [40, 40], iconAnchor: [20, 20] });
//       if (!markerRef.current) {
//         markerRef.current = L.marker([currentLocation.lat, currentLocation.lng], { icon: locationIcon }).addTo(mapRef.current);
//       } else {
//         markerRef.current.setLatLng([currentLocation.lat, currentLocation.lng]);
//       }
//     }
//   }, [currentLocation]);

//   const handleApplyFilters = useCallback((filteredData) => {
//     setFilteredTrees(filteredData);
//     if (filteredData.length > 0 && mapRef.current) {
//       const bounds = L.latLngBounds(
//         filteredData.map((tree) => [tree.geometry.coordinates[0], tree.geometry.coordinates[1]])
//       );
//       mapRef.current.fitBounds(bounds, { padding: [50, 50], duration: 1.5 });
//     }
//   }, []);

//   const handleResetFilters = useCallback(() => {
//     setFilteredTrees(trees);
//     if (mapRef.current) mapRef.current.flyTo(position, 11.5, { duration: 1.2 });
//   }, [trees, position]);

//   const createCustomClusterIcon = useCallback((cluster) => {
//     const clusterCount = cluster.getChildCount();
//     return L.divIcon({
//       html: `
//         <div class="enhanced-cluster-icon" style="background-color: #B6F092;">
//           <img src="${TreeIcon}" alt="Tree" />
//           <div class="cluster-count">${clusterCount}</div>
//         </div>
//       `,
//       className: "enhanced-cluster-wrapper",
//       iconSize: [50, 50],
//     });
//   }, []);

//   const ZoomControl = () => {
//     const map = useMap();
//     const handleZoomIn = () => {
//       map.zoomIn();
//     };
//     const handleZoomOut = () => {
//       map.zoomOut();
//     };
//     return (
//       <div
//         style={{
//           marginTop: "205px",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           padding: "10px 0",
//           marginBottom: "5px",
//           border: "none",
//           borderRadius: "5px",
//           cursor: "pointer",
//           width: "39px",
//           height: "auto",
//           marginLeft: "30px",
//           backgroundColor: "white",
//           outline: "none",
//           position: "absolute",
//         }}
//       >
//         <button
//           onClick={handleZoomIn}
//           style={{
//             color: "grey",
//             fontSize: "16px",
//             paddingTop: "5px",
//             marginTop: "2px",
//             border: "none",
//             backgroundColor: "transparent",
//             width: "20px",
//             textAlign: "center",
//             height: "100%",
//             outline: "none",
//           }}
//         >
//           +
//         </button>
//         <div style={{ width: "3px", height: "0.5px", backgroundColor: "white", margin: "10px 0" }}></div>
//         <button
//           onClick={handleZoomOut}
//           style={{
//             color: "grey",
//             fontSize: "16px",
//             paddingBottom: "5px",
//             border: "none",
//             backgroundColor: "transparent",
//             width: "20px",
//             height: "auto",
//             textAlign: "center",
//             marginBottom: "0px",
//             outline: "none",
//           }}
//         >
//           -
//         </button>
//       </div>
//     );
//   };

//   const markers = useMemo(() => {
//     const dataToRender = filteredTrees.length > 0 ? filteredTrees : trees;
//     return dataToRender
//       .map((tree) => {
//         if (
//           !tree.geometry?.coordinates ||
//           !Array.isArray(tree.geometry.coordinates) ||
//           tree.geometry.coordinates.length !== 2 ||
//           isNaN(tree.geometry.coordinates[0]) ||
//           isNaN(tree.geometry.coordinates[1])
//         ) {
//           console.warn("Invalid tree data:", tree);
//           return null;
//         }
//         const [lat, lng] = tree.geometry.coordinates;
//         if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
//           console.warn(`Invalid coordinates for tree ${tree.properties.tid}: [${lat}, ${lng}]`);
//           return null;
//         }
//         return (
//           <Marker
//             key={tree.properties.tid}
//             position={[lat, lng]}
//             icon={treeIconInstance}
//             eventHandlers={{ click: () => handleMarkerClick(tree) }}
//           />
//         );
//       })
//       .filter(Boolean);
//   }, [filteredTrees, trees, handleMarkerClick, treeIconInstance]);

//   return (
//     <div style={{ position: "relative", height: "100%", width: "100%" }}>
//       {loading && <div className="loading-overlay">Loading...</div>}
//       <MapContainer
//         center={position}
//         zoom={11.5}
//         style={{ width: "100%", height: "100vh" }}
//         maxBounds={indiaBounds}
//         maxBoundsViscosity={1.0}
//         zoomControl={false}
//         ref={mapRef}
//         whenCreated={(map) => (mapRef.current = map)}
//       >
//         {selectedLayer === "Street" && (
//           <TileLayer
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             maxZoom={22}
//             attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//           />
//         )}
//         {selectedLayer === "Satellite" && (
//           <TileLayer
//             url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
//             maxZoom={22}
//             attribution='&copy; <a href="https://www.esri.com/">Esri</a>'
//           />
//         )}
//         {selectedLayer === "OpenStreetMap" && (
//           <TileLayer
//             url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
//             maxZoom={22}
//             attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//           />
//         )}

//         <div className="button-container">
//           <button
//             onClick={handleLayerToggle}
//             style={{
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               padding: "5px",
//               margin: "5px",
//               backgroundColor: activeButton === "layer" ? "#e0e0e0" : "transparent",
//             }}
//             aria-label="Toggle Layer Dropdown"
//           >
//             <LayerIcon />
//           </button>
//           {isDropdownOpen && (
//             <LayerDropdown
//               onLayerChange={(layer) => {
//                 setSelectedLayer(layer);
//                 setDropdownOpen(false);
//               }}
//               selectedLayer={selectedLayer}
//               onClose={() => setDropdownOpen(false)}
//             />
//           )}
//           <button
//             onClick={handleFlyToCurrentLocation}
//             style={{
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               padding: "5px",
//               margin: "5px",
//               backgroundColor: activeButton === "currentLoc" ? "#e0e0e0" : "transparent",
//             }}
//             aria-label="Go to Current Location"
//           >
//             <RulerIcon />
//           </button>
//           <button
//             onClick={handleFilterToggle}
//             style={{
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               padding: "5px",
//               margin: "5px",
//               backgroundColor: activeButton === "filter" ? "#e0e0e0" : "transparent",
//             }}
//             aria-label="Toggle Filter Panel"
//           >
//             <FilterIcon />
//           </button>
//           {showFilterPanel && (
//             <div ref={filterPanelRef}>
//               <FilterPanel
//                 data={filteredTrees.length > 0 ? filteredTrees : trees}
//                 onApplyFilters={handleApplyFilters}
//                 onResetFilters={handleResetFilters}
//               />
//             </div>
//           )}
//           <ZoomControl />
//         </div>

//         <MarkerClusterGroup iconCreateFunction={createCustomClusterIcon} chunkedLoading>
//           {markers}
//         </MarkerClusterGroup>

//         {selectedTree && (
//           <TreeInfoModal
//             key={selectedTree?.properties?.tid}
//             tree={selectedTree}
//             visible={isModalVisible}
//             onClose={handleModalClose}
//             currentLocation={currentLocation}
//           />
//         )}
//       </MapContainer>
//     </div>
//   );
// };

// export default MapComponent;
import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal, message } from "antd";
import React, { useState } from "react";
import CalendarIcon from "../images/calendar.svg";
import GirthIcon from "../images/Girth.svg";
import LatitudeIcon from "../images/Latitude.svg";
import LongitudeIcon from "../images/Longitude.svg";
import QRCODEIcon from "../images/QRCodeIcon.svg";
import DirectionsIcon from "../images/DirectionIcon.svg";
import "./TreeInfoModal.css";

const TreeInfoModal = ({ tree, visible, onClose, currentLocation }) => {
  const [zoomStyle, setZoomStyle] = useState({});
  const [zoomVisible, setZoomVisible] = useState(false);
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [qrModalVisible, setQrModalVisible] = useState(false);

  if (!tree || !tree.properties) return null;

  const imageUrl = tree.properties.thumbnail
    ? `${tree.properties.thumbnail}?t=${new Date().getTime()}`
    : "https://via.placeholder.com/150?text=No+Image";

  const handleMouseMove = (e) => {
    const { width, height, left, top } = e.target.getBoundingClientRect();
    const mouseX = e.clientX - left;
    const mouseY = e.clientY - top;
    const zoomX = (mouseX / width) * 100;
    const zoomY = (mouseY / height) * 100;
    setZoomStyle({
      backgroundPosition: `${zoomX}% ${zoomY}%`,
      backgroundSize: `${width * 2}% ${height * 2}%`,
    });
    setZoomVisible(true);
  };

  const handleMouseLeave = () => setZoomVisible(false);
  const handleImageClick = () => setImageModalVisible(true);
  const handleImageModalClose = () => setImageModalVisible(false);
  const handleQrClick = () => setQrModalVisible(true);
  const handleQrModalClose = () => setQrModalVisible(false);

  const handleDirectionsClick = () => {
    if (!currentLocation || !tree.geometry?.coordinates) {
      message.error("Current location or tree location not available.");
      return;
    }
    const [treeLat, treeLng] = tree.geometry.coordinates; // [lat, lng]
    const { lat: currentLat, lng: currentLng } = currentLocation;
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${treeLat},${treeLng}`;
    window.open(googleMapsUrl, "_blank");
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={765}
      closable={false}
      className="tree-info-modal"
    >
      <div className="close-button-container">
        <Button
          icon={<CloseOutlined />}
          onClick={onClose}
          type="text"
          className="close-button"
        />
      </div>

      <div className="tree-modal-container">
        <div
          className="tree-image-container"
          // onMouseMove={handleMouseMove}
          // onMouseLeave={handleMouseLeave}
          onClick={handleImageClick}
        >
          <img src={imageUrl} alt="Tree" className="tree-image" />
        </div>

        <div className="tree-info-container">
          <p className="tree-id">ID: {tree.properties.tid || "N/A"}</p>
          <p className="tree-name">
            Tree Name: <span>{tree.properties.species_name || "N/A"}</span>
          </p>
          <p className="tree-scientific-name">
            Scientific Name: <span>{tree.properties.species_scientific_name || "N/A"}</span>
          </p>
          <p className="tree-location">
            Project: <span>{tree.properties.project_name || "N/A"}</span>
          </p>
          <p className="tree-ownership">
            Ownership: <span>{tree.properties.ownership || "N/A"}</span>
          </p>

          <div className="tree-additional-info">
            <div className="tree-info-item">
              <div>
                <img src={CalendarIcon} alt="Calendar Icon" /> Date
              </div>
              <span>{tree.properties.created_at ? new Date(tree.properties.created_at).toLocaleDateString() : "N/A"}</span>
            </div>
            <div className="tree-info-item">
              <div>
                <img src={GirthIcon} alt="Girth Icon" /> Girth
              </div>
              <span>{tree.properties.girth ? `${tree.properties.girth} m` : "N/A"}</span>
            </div>
            <div className="tree-info-item">
              <div>
                <img src={LatitudeIcon} alt="Latitude Icon" /> Latitude
              </div>
              <span>{tree.geometry?.coordinates?.[0]?.toFixed(4) || "N/A"}</span>
            </div>
            <div className="tree-info-item">
              <div>
                <img src={LongitudeIcon} alt="Longitude Icon" /> Longitude
              </div>
              <span>{tree.geometry?.coordinates?.[1]?.toFixed(4) || "N/A"}</span>
            </div>
          </div>

          <div className="action-buttons">
            <div className="action-item">
              <img src={DirectionsIcon} alt="Directions Icon" onClick={handleDirectionsClick} />
              <button onClick={handleDirectionsClick}>GET DIRECTIONS</button>
            </div>
            {tree.properties.qr_code && (
              <div className="action-item">
                <img src={QRCODEIcon} alt="QR Code" onClick={handleQrClick} />
                <button onClick={handleQrClick}>SCAN TO VIEW INFORMATION</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {zoomVisible && (
        <div className="zoom-panel" style={zoomStyle}>
          <div style={{ backgroundImage: `url(${imageUrl})` }} />
        </div>
      )}

      <Modal
        visible={imageModalVisible}
        onCancel={handleImageModalClose}
        footer={null}
        className="image-modal"
      >
        <img src={imageUrl} alt="Tree" />
      </Modal>

      <Modal
        visible={qrModalVisible}
        onCancel={handleQrModalClose}
        footer={null}
        className="qr-modal"
      >
        <img src={tree.properties.qr_code || "https://via.placeholder.com/150?text=No+QR+Code"} alt="QR Code" />
      </Modal>
    </Modal>
  );
};

export default TreeInfoModal;